

module.exports = __webpack_require__.stylable.create(
    "Contact1899373500",
    {"classes":{"root":"Contact1899373500__root","locationName":"Contact1899373500__locationName","businessLocations":"Contact1899373500__businessLocations","businessLocation":"Contact1899373500__businessLocation"},"vars":{"columnGap":"--Contact1899373500-columnGap","rowGap":"--Contact1899373500-rowGap","maxNumberOfColumns":"--Contact1899373500-maxNumberOfColumns"},"stVars":{},"keyframes":{}},
    "",
    1,
    "Contact1899373500",
    null
);
